import { apiRequest } from '../api/client';

export function createExerciseAdminApi({ fetchImpl } = {}) {
  const request = (path, options) => apiRequest(path, { ...options, fetchImpl });
  return {
    listExercises: (params = {}) => {
      const query = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') query.set(key, String(value));
      });
      const suffix = query.toString();
      return request(`/exercises${suffix ? `?${suffix}` : ''}`).then((r) => r);
    },
    saveExerciseMedia: (id, body) => request(`/exercises/${encodeURIComponent(id)}/media`, {
      method: 'PUT', body,
    }).then((r) => r.exercise),
    deleteExerciseMedia: (id) => request(`/exercises/${encodeURIComponent(id)}/media`, { method: 'DELETE' })
      .then((r) => r && r.exercise),
    // Etapa 2: ejercicios propios y nombre propio.
    getExerciseOptions: () => request('/exercises/options'),
    createExercise: (body) => request('/exercises', { method: 'POST', body }).then((r) => r.exercise),
    updateExercise: (id, body) => request(`/exercises/${encodeURIComponent(id)}`, { method: 'PATCH', body }).then((r) => r.exercise),
    archiveExercise: (id) => request(`/exercises/${encodeURIComponent(id)}/archive`, { method: 'POST' }).then((r) => r.exercise),
    unarchiveExercise: (id) => request(`/exercises/${encodeURIComponent(id)}/unarchive`, { method: 'POST' }).then((r) => r.exercise),
    setExerciseName: (id, customName) => request(`/exercises/${encodeURIComponent(id)}/name`, { method: 'PUT', body: { customName } }).then((r) => r.exercise),
    removeExerciseName: (id) => request(`/exercises/${encodeURIComponent(id)}/name`, { method: 'DELETE' }).then((r) => r.exercise),
  };
}

export const exerciseAdminApi = createExerciseAdminApi();
